module.exports = __webpack_public_path__ + "img/banner1.d3da2a09.png";